module.exports = __webpack_public_path__ + "static/img/yijiemeng.b4a01689.png";